import { Component, computed, inject, ChangeDetectionStrategy, signal } from '@angular/core';
import { AuthenticationService } from '../../authentication/authentication.service';
import { hasRole, Role } from '../../shared/enums/role';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MceApiService } from '../../core/mceapi.client.generated';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { InfoMessageComponent } from '../../shared/components/info-message/info-message.component';

type BillingPlanKey = 'free' | 'pro';

interface BillingPlan {
  key: BillingPlanKey;
  name: string;
  billing: string;
  credits: number;
  overage: string;
}

@Component({
  selector: 'mce-account-subscription',
  imports: [ InfoMessageComponent,  MatCardModule, MatButtonModule, MatIconModule,
              MatProgressSpinnerModule  ],  
    templateUrl: './subscription.component.html'
})
export class AccountSubscriptionComponent {

  authenticationService = inject(AuthenticationService);
  mceApiService = inject(MceApiService);

  protected readonly billingPlans: BillingPlan[] = [
    {
      key: 'free',
      name: 'Free',
      billing: 'No paid subscription',
      credits: 30,
      overage: 'Hard cap, no PAYG',
    },
    {
      key: 'pro',
      name: 'Pro',
      billing: '£10.00 monthly subscription',
      credits: 60,
      overage: '£0.15 per credit',
    },
  ];

  protected readonly loading = signal(false);

  protected readonly viewState = computed(() => {
    let roles = this.authenticationService.currentUserRoles();
    const freePlan = hasRole(roles, Role.FreeTier);
    const proPlan = hasRole(roles, Role.ProTier);
    const currentPlanKey: BillingPlanKey =
      proPlan ? 'pro' :
        'free';
    const currentPlan = this.billingPlans.find(plan => plan.key === currentPlanKey) ?? this.billingPlans[0];
    const paidPlans = this.billingPlans.filter(plan => plan.key !== 'free');

    return {
      freePlan,
      proPlan,
      hasPaidSubscription: proPlan,
      currentPlanKey,
      currentPlanName: currentPlan.name,
      currentPlanBilling: currentPlan.billing,
      currentPlanCredits: currentPlan.credits,
      currentPlanOverage: currentPlan.overage,
      billingPlans: this.billingPlans,
      purchasePlans: paidPlans,
      loading: this.loading()
    };
  });

  protected checkoutOnClick(plan: BillingPlan) {
    console.log('TODO: request Stripe checkout session for plan', plan);

    // TODO: Add processing to button .......

    this.loading.set(true);

    let request = {
      tier: { tier: plan.key },
      successUrl: window.location.href, 
      cancelUrl: window.location.href
    }

    this.mceApiService.v1SubscriptionsSessionCheckout(request).subscribe(session => {
      this.loading.set(false);
      if(session.url) window.location.href = session.url;
    });

  }

  protected managePlanOnClick() {
    this.loading.set(true);

    const request = {
      returnUrl: window.location.href
    };

    this.mceApiService.v1SubscriptionsSessionPortal(request).subscribe(session => {
      this.loading.set(false);
      if (session.url) window.location.href = session.url;
    });
  }

  protected checkoutLabel(plan: BillingPlan) {
    return `Purchase ${plan.name}`;
  }



}
